import React from "react";
import SkeletonArticle from "../../components/Post_skaliton/SkeletonArticle";
// import PostContent from "./PostContent";
import GuestPostContent from "./GuestPostContent";

const GuestPost = ({ posts, status }) => {
    return (
        <center>
            {status &&
            [1, 2, 3, 4].map((i) => <SkeletonArticle key={i} theme="dark" />)}

            {
                 posts && posts.map((data) =>
                     <GuestPostContent key={data.id} post={data} />
                     )
            }

        </center>
    );
};

export default GuestPost;
